import { render, staticRenderFns } from "./detailsAboutNewUser.vue?vue&type=template&id=b8528ca2&scoped=true"
import script from "./detailsAboutNewUser.vue?vue&type=script&lang=js"
export * from "./detailsAboutNewUser.vue?vue&type=script&lang=js"
import style0 from "./detailsAboutNewUser.vue?vue&type=style&index=0&id=b8528ca2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8528ca2",
  null
  
)

export default component.exports